module.exports = __webpack_public_path__ + "img/go-pri.32387613.svg";